import { render } from "./SectionTopMenu.vue?vue&type=template&id=17f22032"
import script from "./SectionTopMenu.vue?vue&type=script&lang=js"
export * from "./SectionTopMenu.vue?vue&type=script&lang=js"

import "./SectionTopMenu.vue?vue&type=style&index=0&id=17f22032&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__